export default __webpack_public_path__ + "static/media/170.1bc36723.gif";